<script>
import Swal from "sweetalert2";
import BankAccountForm from "@/components/bank-accounts/BankAccountForm.vue";
import TransferRequestTable from "@/components/transfer-request/Table.vue";
/**
 * Dashboard component
 */
export default {
  components: {
    BankAccountForm,
    TransferRequestTable,
  },
  computed: {
    bank_accounts() {
      return this.$store.state.tables.bankAccounts.data;
    },
  },
  data() {
    return {
      title: "کیف پول من",
      items: [
        {
          text: "کیف پول من",
          active: true,
        },
      ],
      income: 0,
      wallet_balance: 0,
      backAccountsDetail: JSON.parse(
        JSON.stringify(this.$store.state.tables.bankAccounts)
      ),
      selectedAccount: null,
      showBankAccountForm: false,
      newTransferRequest: {},
      sms_token_id: null,
      sms_token: "",
    };
  },

  mounted() {
    this.fetchMetaData();
  },
  methods: {
    fetchMetaData() {
      this.$axios.get("financial/meta-data").then((res) => {
        this.income = res.data.income;
        this.wallet_balance = res.data.wallet_balance;
        this.backAccountsDetail.data = res.data.bank_accounts;
        this.$store.commit("tables/UPDATE_TABLE_DETAIL", {
          key: "bankAccounts",
          table: JSON.parse(JSON.stringify(this.backAccountsDetail)),
        });
      });
    },
    incomeTransfer() {
      this.wallet_balance += this.income;
      this.income = 0;
    },
    requestToken(item) {
      let data = {};
      let route = `transfer-requests/request-token`;
      if (item) {
        data = item;
        data.bank_account_id = item.bank_account.id;
        route = `transfer-requests/${item.id}/request-token`;
      } else {
        data.bank_account_id = this.selectedAccount.id;
      }
      this.$axios.post(route, data).then((res) => {
        if (!item) {
          this.wallet_balance = 0;
          this.$store.dispatch("tables/addNewItem", {
            key: "transferRequests",
            item: res.data.transfer_request,
          });
        }
        this.newTransferRequest = JSON.parse(
          JSON.stringify(res.data.transfer_request)
        );
        this.sms_token_id = res.data.token_id;
        this.$refs["transfer-modal"].hide();
        this.$refs["sms-token-modal"].show();
      });
    },
    confirmToken() {
      this.$axios
        .post(
          `transfer-requests/${this.newTransferRequest.id}/token-validation`,
          {
            token_id: this.sms_token_id,
            sms_token: this.sms_token,
          }
        )
        .then((res) => {
          this.$store.dispatch("tables/updateItem", {
            key: "transferRequests",
            item: res.data,
          });
          this.newTransferRequest = {};
          Swal.fire("موفق!", `درخواست شما با موفقیت ثبت شد`, "success").then(
            () => {
              this.$refs["sms-token-modal"].hide();
              this.sms_token = "";
            }
          );
        });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <template>
      <div class="row">
        <div class="col-md-12">
          <div>
            <div class="card">
              <div class="card-body">
                <h5>دریافت مبلغ کیف پول</h5>
                <p class="mt-4">
                  مبلغ موجودی کیف پول:
                  {{ $helper.formatPrice(wallet_balance) }} تومان
                </p>
                <b-button v-b-modal.transfer-modal variant="danger"
                  >دریافت پول</b-button
                >
              </div>
            </div>
            <b-modal
              id="transfer-modal"
              ref="transfer-modal"
              hide-footer
              title="دریافت مبلغ کیف پول"
            >
              <ValidationObserver
                ref="step0"
                v-slot:="{ handleSubmit }"
                tag="div"
              >
                <form
                  class="needs-validation"
                  @submit.prevent="handleSubmit(requestToken)"
                >
                  <div class="flex flex-column">
                    <div class="col-12">
                      <validation-select
                        v-model="selectedAccount"
                        rules="required"
                        :options="bank_accounts"
                        placeholder="کارت مقصد"
                        option-value-key="id"
                        :option-text-key="['name', 'ownerName', 'cardInfo']"
                        validation-field-name="کارت مقصد"
                        label="کارت مقصد"
                      ></validation-select>
                    </div>
                    <div class="col-12">
                      <span
                        class="btn btn-warning mt-4"
                        @click="showBankAccountForm = true"
                        >افزودن کارت جدید</span
                      >
                      <button
                        class="btn btn-success mt-4"
                        style="float: left"
                        type="submit"
                      >
                        ارسال درخواست
                      </button>
                    </div>
                  </div>
                </form>
              </ValidationObserver>
            </b-modal>
            <BankAccountForm
              v-if="showBankAccountForm"
              @hidden="showBankAccountForm = false"
            />
            <b-modal
              ref="sms-token-modal"
              id="sms-token-modal"
              hide-footer
              title="کد تأیید"
            >
              <ValidationObserver
                ref="step0"
                v-slot:="{ handleSubmit }"
                tag="div"
              >
                <form
                  class="needs-validation"
                  @submit.prevent="handleSubmit(confirmToken)"
                >
                  <div class="flex flex-column">
                    <div class="col-12">
                      <validation-input
                        v-model="sms_token"
                        rules="required"
                        placeholder="کد تایید پیامک شده را وارد کنید"
                        validation-field-name="کد تایید"
                        label="کد تایید"
                      ></validation-input>
                    </div>
                    <div class="col-12">
                      <button
                        class="btn btn-success mt-4"
                        style="float: left"
                        type="submit"
                      >
                        ارسال درخواست
                      </button>
                    </div>
                  </div>
                </form>
              </ValidationObserver>
            </b-modal>
          </div>
        </div>
        <div class="col-12">
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-body">
                  <h5>درخواست های پرداخت ثبت شده</h5>
                  <TransferRequestTable
                    ref="table"
                    @request-token="requestToken"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Layout>
</template>
